export default __webpack_public_path__ + "static/webhook-page-0c86d874d10234899f305c1b77e0ade8.png";